import {METRIC_OPTIONS, METRIC_GROUP_CONFIGS} from 'features/admin/lib/metrics';

import React from 'react';

import Checkbox from 'shared/ui/Checkbox/Checkbox';

import MetricGroup from '../MetricGroup/MetricGroup';

import styles from './MetricSelector.module.scss';

interface MetricSelectorProps {
    selectedMetrics: string[];
    // eslint-disable-next-line no-unused-vars
    onMetricToggle: (metricId: string) => void;
    // eslint-disable-next-line no-unused-vars
    onSelectGroup: (groupMetrics: string[]) => void;
    // eslint-disable-next-line no-unused-vars
    onDeselectGroup: (groupMetrics: string[]) => void;
}

const MetricSelector: React.FC<MetricSelectorProps> = ({
    selectedMetrics,
    onMetricToggle,
    onSelectGroup,
    onDeselectGroup,
}) => {
    return (
        <div className={styles.section}>
            <h4>Метрики:</h4>
            <div className={styles.container}>
                <div className={styles.metricGroups}>
                    {METRIC_GROUP_CONFIGS.map((group) => (
                        <MetricGroup
                            key={group.key}
                            title={group.title}
                            metrics={group.metrics}
                            selectedMetrics={selectedMetrics}
                            onSelectGroup={onSelectGroup}
                            onDeselectGroup={onDeselectGroup}
                        />
                    ))}
                </div>
                <div className={styles.list}>
                    {METRIC_OPTIONS.map(metric => {
                        const isChecked = selectedMetrics.includes(metric.id);

                        return (
                            <div key={metric.id} className={styles.item}>
                                <Checkbox
                                    checked={isChecked}
                                    onChange={() => onMetricToggle(metric.id)}
                                    className={styles.checkbox}
                                >
                                    <div className={styles.label}>
                                        <span
                                            className={styles.colorIndicator}
                                            style={{ backgroundColor: metric.color }}
                                        />
                                        {metric.label}
                                    </div>
                                </Checkbox>
                            </div>
                        );
                    })}
                </div>
            </div>
        </div>
    );
};

export default MetricSelector;